<template>
    <div v-loading="$parentInfo.renewDetail_loading">
        <vue-scroll :ops="$ops" :style="{'height':$parentInfo.clientHeight-96+'px'}" >
            <div style="padding-left: 10px">
                <div>
                    <el-form label-position="left">
                        <el-form-item label="状态">
                            <el-select v-model="$parentInfo.status" filterable remote @change="handleChange()">
                                <el-option
                                        v-for="item in status_array"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <el-collapse v-model="activeNames">
                    <el-collapse-item title="基本信息" name="a">
                        <div>学校：{{$parentInfo.renewDetail.school_name}}</div>
                        <div>年级：{{$parentInfo.renewDetail.grade_name}}</div>
                        <div>电话号码：{{$parentInfo.renewDetail.phone}}</div>
                        <div>在读科目及老师：
                            <span v-for="student_subject in $parentInfo.renewDetail.student_subjects">
                            {{student_subject.subject_name}}-{{student_subject.employees_name}}；
                        </span>
                        </div>
                    </el-collapse-item>
                    <el-collapse-item title="年级特点及政策背景" name="b">
                        <div>暂无</div>
                    </el-collapse-item>
                    <el-collapse-item  :name="index" v-for="(studentRenewTime,index) in orderStudentRenewTimes" :key="index"  :title="studentRenewTime.name"  @click="handleChangeActive">
                        <el-collapse v-model="activeNames" style="padding-left: 15px">
                            <el-collapse-item v-for="(item,index1) in studentRenewTime.content" :key="index1" :title="item.title">
                                <el-form label-position="top" >
                                    <el-form-item v-for="(item1,index1) in item.content" :label="item1.problem" :key="index1" >
                                        <el-input
                                                type="textarea"
                                                :autosize="{ minRows: 1, maxRows: 20}"
                                                placeholder=""
                                                v-model="item1.answer"
                                                @blur="handleSave(studentRenewTime,'active')"
                                                :disabled="studentRenewTime.status=='finished'"
                                        >
                                        </el-input>
                                    </el-form-item>
                                </el-form>
                            </el-collapse-item>
                        </el-collapse>
                        <div style="text-align: right">
                            <el-button type="primary" @click="handleSave(studentRenewTime,'finished')">结束回访</el-button>
                        </div>
                    </el-collapse-item>
                    <el-collapse-item title="日志" name="c">
                        <div style="text-align: right">
                            <el-button type="primary" @click="handleAddDetail">开始续班</el-button>
                        </div>
                        <el-timeline :reverse="reverse">
                            <el-timeline-item
                                    v-for="(activity, index) in $parentInfo.renewDetail.logs"
                                    :key="index"
                                    :timestamp="activity.created_at">
                                {{activity.name}}
                            </el-timeline-item>
                        </el-timeline>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </vue-scroll>
        <el-drawer
                title="添加回访"
                :append-to-body="true"
                :before-close="handleClose"
                :visible.sync="$parentInfo.innerDrawer">
            <div>
                <el-form label-position="top">
                    <el-form-item label="回访方式">
                        <el-select v-model="type" clearable placeholder="请选择回访方式" filterable remote
                        >
                            <el-option
                                    v-for="item in types"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                        <el-button @click="handleCreateDetail">保存</el-button>
                    </el-form-item>
                    <el-form-item label="模板">
                        <vue-scroll :ops="$ops" :style="{'height':$parentInfo.clientHeight-250+'px'}" >
                            <el-form label-position="top" v-if="type=='phone' || type=='weChat'">
                                <div v-for="(item,index) in phoneModel" :key="index">
                                    <div style="font-size: 20px">
                                        {{item.title}}
                                    </div>
                                    <el-form-item v-for="(item1,index1) in item.content" :label="item1.problem" :key="index1">
                                        <el-input
                                                type="textarea"
                                                :autosize="{ minRows: 1, maxRows: 20}"
                                                placeholder=""
                                                v-model="item1.content"
                                                disabled
                                        >
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </el-form>
                            <el-form label-position="top" v-else-if="type=='offline'">
                                <div v-for="(item,index) in offlineModel" :key="index">
                                    <div style="font-size: 20px">
                                        {{item.title}}
                                    </div>
                                    <el-form-item v-for="(item1,index1) in item.content" :label="item1.problem" :key="index1">
                                        <el-input
                                                type="textarea"
                                                :autosize="{ minRows: 1, maxRows: 20}"
                                                placeholder=""
                                                v-model="item1.content"
                                                disabled
                                        >
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </el-form>
                        </vue-scroll>
                    </el-form-item>
                </el-form>

            </div>
        </el-drawer>
    </div>
</template>

<script>
    export default {
        name: "RenewDetail",
        data() {
            return {
                activeNames: ['0'],
                detailActiveNames: [],
                direction:'btt',
                reverse: true,
                drawer: false,
                innerDrawer: false,
                type:'',
                types:[
                    {
                        'id':'phone',
                        'name':'电话'
                    },
                    {
                        'id':'offline',
                        'name':'到店'
                    },
                    {
                        'id':'weChat',
                        'name':'微信'
                    }
                ],
                status_array:[
                    {
                        'id':'active',
                        'name':'未开始'
                    },
                    {
                        'id':'hesitate',
                        'name':'犹豫'
                    },
                    {
                        'id':'appoint',
                        'name':'预约'
                    },
                    {
                        'id':'rushFee',
                        'name':'催费'
                    },
                    {
                        'id':'reject',
                        'name':'拒绝'
                    },
                ],
                phoneModel:[
                    {
                        id:1,
                        title:'在读学科1',
                        content: [
                            {
                                id:1,
                                problem:'（成绩）：',
                                answer:'',
                            },
                            {
                                id:2,
                                problem:'在读情况及学习问题：',
                                answer:'',
                            },
                            {
                                id:3,
                                problem:'问题的解决方案或学习建议：',
                                answer:'',
                            },
                            {
                                id:4,
                                problem:'续班理由：',
                                answer:'',
                            },
                            {
                                id:5,
                                problem:'在读学科续班结果：续班/未续班【电话行为中】',
                                answer:'',
                            },
                            {
                                id:6,
                                problem:'（选择未续班）在读学科不续班理由：',
                                answer:'',
                            },
                            {
                                id:7,
                                problem:'不续班解决方案：【电话行为后准备】',
                                answer:'',
                            },
                        ],
                    },
                    {
                        id:2,
                        title:'非在读学科1:',
                        content: [
                            {
                                id:1,
                                problem:'学习情况：',
                                answer:'',
                            },
                            {
                                id:2,
                                problem:'扩班理由：',
                                answer:'',
                            },
                            {
                                id:3,
                                problem:'推荐老师：',
                                answer:'',
                            },
                            {
                                id:4,
                                problem:'老师特点如何对应学生问题：',
                                answer:'',
                            },
                            {
                                id:5,
                                problem:'非在读课多报结果：报名/未报名',
                                answer:'',
                            },
                            {
                                id:6,
                                problem:'（选择未报名）不报名理由：',
                                answer:'',
                            },
                            {
                                id:7,
                                problem:'不报名解决方案：【电话行为后准备】',
                                answer:'',
                            },
                        ],
                    },
                    {
                        id:3,
                        title:'其它',
                        content: [
                            {
                                id:1,
                                problem:'学生意向征询结果：',
                                answer:'',
                            },
                            {
                                id:2,
                                problem:'转介绍话术：（默认给出）',
                                answer:'',
                            },
                            {
                                id:3,
                                problem:'转介绍结果：',
                                answer:'',
                            },
                            {
                                id:4,
                                problem:'（成交后）家长是否转发朋友圈：',
                                answer:'',
                            },
                            {
                                id:5,
                                problem:'是否约到店：是/否',
                                answer:'',
                            },
                            {
                                id:6,
                                problem:'（选择是）到店时间：',
                                answer:'',
                            },
                        ],
                    },
                ],
                offlineModel:[
                    {
                        id:1,
                        title:'在读学科1',
                        content: [
                            {
                                id:1,
                                problem:'（成绩）：',
                                answer:'',
                            },
                            {
                                id:2,
                                problem:'在读情况及学习问题：',
                                answer:'',
                            },
                            {
                                id:3,
                                problem:'问题的解决方案或学习建议：',
                                answer:'',
                            },
                            {
                                id:4,
                                problem:'续班理由：',
                                answer:'',
                            },
                            {
                                id:5,
                                problem:'不续班解决结果：续班/未续班',
                                answer:'',
                            },
                            {
                                id:6,
                                problem:'（选择未续班）在读学科不续班理由：',
                                answer:'',
                            },
                        ],
                    },
                    {
                        id:2,
                        title:'非在读学科1:',
                        content: [
                            {
                                id:1,
                                problem:'学习情况：',
                                answer:'',
                            },
                            {
                                id:2,
                                problem:'扩班理由：',
                                answer:'',
                            },
                            {
                                id:3,
                                problem:'推荐老师：',
                                answer:'',
                            },
                            {
                                id:4,
                                problem:'老师特点如何对应学生问题：',
                                answer:'',
                            },
                            {
                                id:5,
                                problem:'不报名解决结果：报名/未报名',
                                answer:'',
                            },
                            {
                                id:6,
                                problem:'（选择未报名）不报名理由：',
                                answer:'',
                            },
                        ],
                    },
                    {
                        id:3,
                        title:'其它',
                        content: [
                            {
                                id:1,
                                problem:'学生意向征询结果：',
                                answer:'',
                            },
                            {
                                id:2,
                                problem:'转介绍话术：（默认给出）',
                                answer:'',
                            },
                            {
                                id:3,
                                problem:'（成交后）家长是否转发朋友圈：',
                                answer:'',
                            },
                        ],
                    },
                ],
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleDetail()
        },
        computed: {
            orderStudentRenewTimes: function () {
                return this._.orderBy(this.$parentInfo.renewDetail.studentRenewTimes, 'id', 'desc');
            }
        },
        methods: {
            handleDetail(){
                this.$parentInfo.renewDetail_loading=true;
                this.$wApi.send(this.$parentInfo.path, 'get_renew_detail', {
                    'student_id': this.$parentInfo.choose_student_id,
                })
            },
            handleClose(done) {
                this.$confirm('还有未保存的工作哦确定关闭吗？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
            handleAddDetail(){
                this.$parentInfo.innerDrawer = true
            },
            handleCreateDetail(){
                let model=[];
                if(this.type=='phone' || this.type=='weChat'){
                    model=this.phoneModel
                }else{
                    model=this.offlineModel
                }
                this.$wApi.send(this.$parentInfo.path, 'store_student_renew_time', {
                    'student_id': this.$parentInfo.choose_student_id,
                    'type': this.type,
                    'model':model
                })
            },
            handleSave(studentRenewTime,status){
                this.$wApi.send(this.$parentInfo.path, 'update_student_renew_time', {
                    'student_renew_time_id': studentRenewTime.id,
                    'content': studentRenewTime.content,
                    'status': status,
                })
            },
            handleChange(){
                this.$wApi.send(this.$parentInfo.path, 'change_attitude', {
                    'student_id':  this.$parentInfo.choose_student_id,
                    'status': this.$parentInfo.status,
                    'first_status':this.$parentInfo.renewDetail.status
                })
            },
            handleChangeActive(){
                this.detailActiveNames=[];
            }
        }
    }
</script>

<style scoped>

</style>